import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import CurrentEstateResource from '/@/modules/estate/resources/CurrentEstateResource';

export class CurrentEstateService extends BaseService {
  /**
   * @var {CurrentEstateResource}
   */
  resource;

  constructor() {
    super();

    this.resource = CurrentEstateResource;
  }

  /**
   * @param {int} estateId
   * @return {Promise<*>}
   */
  async setCurrentEstate(estateId) {
    return this.resource.setCurrentEstate({ estateId });
  }

  async clearCurrentEstate() {
    return this.resource.clearCurrentEstate();
  }
}

export default new CurrentEstateService();
